/* src/app/pages/project/map/repository/import-wizard/components/geospatial/_components/minimap/import-wizard-geospatial-minimap.component.scss */
#map {
  width: 100%;
  height: 100%;
  min-height: 400px;
  background: #414141;
}
.large-file-preview {
  display: flex;
  min-height: 400px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 32px;
  border: 1px dashed #c9c9c9;
  border-radius: 12px;
  background: #f7f7f7;
  color: #424242;
  text-align: center;
}
.large-file-preview strong {
  color: #222;
  font-size: 16px;
}
.large-file-preview span {
  max-width: 560px;
  font-size: 14px;
  line-height: 1.4;
}
/*# sourceMappingURL=import-wizard-geospatial-minimap.component-NUGIKEG3.css.map */
